import { Component , OnInit } from '@angular/core';
import * as $ from 'jquery';


@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
})
export class BlogComponent implements OnInit {
  ngOnInit() {
  }
}
